import React from 'react';
import { colors } from '../../../../colorVars';
import { Body3 } from '../../../atomic/text/Text';

export const ActivityLogsTableHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Time
          </Body3>
        </th>
        <th style={{ maxWidth: '90px' }}>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Symbol
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Type
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Status
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
